import { FormControl, InputLabel, MenuItem, Select } from '@mui/material'

function SingleSelect({
  value,
  label,
  onChange,
  isLoading,
  options,
}: {
  value: string
  label: string
  onChange: (newValue: string | string[]) => void
  isLoading: boolean
  options: {
    label: string
    key: string | number
  }[]
}) {
  return (
    <FormControl fullWidth size="small">
      <InputLabel>{label}</InputLabel>
      <Select
        disabled={isLoading}
        value={value}
        label={label}
        onChange={(e) => (!isLoading ? onChange(e.target.value) : null)}
        sx={{ fontSize: '0.875rem' }}
      >
        {options.map((option) => (
          <MenuItem
            key={option.key}
            value={option.key}
            sx={{ fontSize: '0.875rem' }}
          >
            {option.label}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  )
}

export default SingleSelect
